import fetchAPI from '../utils/service';

function searchArticleRequest() {
  return {
    type: 'SEARCH_ARTICLE_REQUEST',
  };
}
function searchArticleSuccess(payload) {
  return {
    type: 'SEARCH_ARTICLE_SUCCESS',
    payload,
  };
}
function searchArticleFailure() {
  return {
    type: 'SEARCH_ARTICLE_FAILURE',
  };
}

function searchArticle(data) {
  return async (dispatch) => {
    await dispatch(searchArticleRequest());
    try {
      if (data.text.length) {
        const res = await fetchAPI({
          endpoints: '/search',
          method: 'POST',
          data,
        });
        if (res.status === 200) {
          await dispatch(searchArticleSuccess(res.data));
        } else {
          await dispatch(searchArticleFailure());
        }
      } else dispatch(searchArticleSuccess([]));
    } catch (error) {
      await dispatch(searchArticleFailure());
    }
  };
}

export {
  searchArticle,
};



// WEBPACK FOOTER //
// ./src/actions/search.js